import "./PrivacyPoliciesBox.css";

export const PrivacyPoliciesBox = () => {

    return (
        <div className="privacy-components-container">
            <div className="headerPrivacy">
                <u className="title-politica">Política de Privacidad y Protección de Datos Personales</u>
                <p>
                    Calculadora IRL: Medidor de nivel de madurez de proyectos de innovación
                </p>
                <span >
                    <p className="subtitle-politica" >1 Objetivo de esta política</p>
                </span>
                <p>
                    La Calculadora IRL es fruto de la colaboración entre APTA (<a href={"https://hubapta.com/"} target="_blank" rel="noreferrer">https://hubapta.com/</a>), HUBTEC
                    (<a href={"http://www.hubtec.cl/"} target="_blank" rel="noreferrer">http://www.hubtec.cl/</a>) y Know Hub (<a href={"https://knowhub.cl/"} target="_blank" rel="noreferrer">https://knowhub.cl/</a>). Cada uno de estos colaboradores aporta su
                    experiencia y recursos para el desarrollo y mejora de la Calculadora IRL, orientada a medir el nivel de
                    madurez de proyectos de innovación y emprendimientos. La Calculadora IRL es administrada de manera
                    colaborativa por APTA, HUBTEC y Know Hub. En adelante, cuando se haga referencia a cualquiera de
                    estas entidades o a los “HUBS”, se entenderá que se refiere a la acción conjunta de estas tres
                    organizaciones.
                </p>
                <p>
                    Esta Política de Privacidad y Protección de Datos Personales, en adelante la “Política”, describe los
                    procedimientos de los HUBS, para procesar, recolectar, usar y divulgar su información personal cuando
                    usted usa nuestra plataforma en la cual se encuentra la Calculadora, disponible en el sitio web
                    calculadorairl.cl.
                </p>
                <p>
                    La presente Política brinda información sobre sus derechos relativos a la protección de datos personales
                    en cumplimiento a la ley 19.628 y el artículo 19 Nº4 de la Constitución Política de la República al utilizar
                    la Calculadora IRL. Al ingresar a la plataforma y utilizar la Calculadora IRL, usted está aceptando el
                    tratamiento de sus datos personales con arreglo a la presente Política.
                </p>
                <p>
                    Toda referencia al “usuario” se entenderá que corresponde a la persona natural que accede y utiliza los
                    servicios alojados en la Plataforma.
                </p>
                <span >
                    <p className="subtitle-politica" >2 Antecedentes</p>
                </span>
                <p>
                    Con la finalidad de impulsar el desarrollo y escalabilidad de proyectos de innovación, los HUBS han
                    desarrollado la herramienta Calculadora IRL, basada en el modelo KTH Innovation Readiness Level™,
                    desarrollado por KTH Innovation bajo la licencia Creative Commons Attribution NonCommercial
                    ShareAlike 4.0 International (CC BY-NC-SA 4.0). El modelo es accesible públicamente a través del
                    siguiente enlace: https://kthinnovationreadinesslevel.com/.
                </p>

                <span >
                    <p className="subtitle-politica" >3 Información del Responsable de Datos</p>

                </span>
                <p>
                    Los responsables del tratamiento de datos son los HUBS:

                </p>
                <ul>
                    <li>APTA<br></br>
                        Domicilio postal: El Director 6000, oficina 203, Las Condes, Santiago, Chile.
                        Correo electrónico: <a href={"mailto:calculadora@hubapta.com"}>calculadora@hubapta.com</a>
                    </li>
                    <li>HUBTEC<br></br>
                        Domicilio postal: Av. Apoquindo 2827, Piso 12, Las Condes, Santiago, Chile.
                        Correo electrónico: <a href={"mailto:calculadora@hubtec.cl"}>calculadora@hubtec.cl</a>
                    </li>
                    <li>Know Hub<br></br>
                        Domicilio postal: Av. Nueva Tajamar 481, Oficina 905 Torre Norte, Las Condes, Santiago, Chile.
                        Correo electrónico: <a href={"mailto:calculadora@knowhub.cl"}>calculadora@knowhub.cl</a>
                    </li>
                </ul>
                <p>Las solicitudes para ejercer los derechos que brinda la ley 19.628 pueden ser dirigidas a cualquiera de los
                    domicilios postales o correos electrónicos mencionados previamente.</p>

                <span >
                    <p className="subtitle-politica" >4 Quienes pueden acceder a la Calculadora</p>

                </span>
                <p>Pueden acceder todas aquellas personas naturales mayores de 18 años o jurídicas legalmente
                    constituidas en Chile o en el extranjero, que consientan expresamente esta Política y la forma de
                    tratamiento de sus datos personales allí descrita.</p>

                <span >
                    <p className="subtitle-politica" >5 Recopilación de datos personales</p>

                </span>
                <p>Al ingresar a nuestra plataforma y utilizar la Calculadora IRL, se le podrá solicitar que proporcione cierta
                    información de carácter personal que puede incluir lo siguiente:</p>
                <ul>
                    <li>Información de contacto personal (ej. nombre, correo electrónico, sexo, cédula de identificación
                        o pasaporte),</li>
                    <li>Información de su domicilio o lugar de trabajo,</li>
                    <li>Rol o cargo laboral que ostenta en el proyecto o empresa.</li>
                </ul>
                <p>Adicionalmente, se recopilan automáticamente datos de uso cuando se ingresa a la plataforma y use la
                    Calculadora IRL, ya sea a través de computadores o dispositivos móviles. Los datos de uso pueden incluir
                    la dirección IP, el navegador, su versión, que páginas ha visitado, hora, fecha, cuanto tiempo estuvo en
                    las mismas, que dispositivo se utilizó el dispositivo único identificadores y otros datos.</p>

                <p>La plataforma puede usar <b>cookies</b> y tecnologías de seguimiento similares para rastrear su actividad por
                    medio de cualquier dispositivo y almacenar esa información. Las tecnologías podrían incluir cookies del
                    navegador, Cookies Flash y Balizas web. Por otra parte, las cookies pueden ser cookies persistentes o de
                    sesión, dependiendo de si la cookie permanece en la computadora o dispositivo personal cuando se
                    desconecta.</p>
                <p>Al proporcionar sus datos personales a través del Sitio Web o los Sitios, usted está aceptando esta
                    Política de Privacidad, y además garantiza que es una persona natural mayor de 18 años y que los datos
                    proporcionados son verdaderos, exactos, completos y actualizados, siendo su responsabilidad mantener
                    actualizada la información.</p>

                <span >
                    <p className="subtitle-politica" >6 Comunicación de Datos Personales</p>
                </span>
                <p>Los HUBS podrán compartir su información personal en las siguientes situaciones:</p>
                <ul>
                    <li>Trabajadores y colaboradores de los HUBS, quienes se encargan de la mantención y
                        administración del sitio web que contiene la Calculadora IRL.</li>
                    <li>Con proveedores de servicios de seguridad informática, de servicios de análisis de datos,
                        proveedores de servicios en la nube, gestión de bases de datos y análisis de tendencias. A estos
                        proveedores se les exigirá que se comprometan a manejar esta información de acuerdo con las
                        obligaciones de confidencialidad y las medidas de seguridad adecuadas.</li>
                    <li>Con universidades o entidades gubernamentales tales como la Agencia Nacional de
                        Investigación (ANID) para el análisis de tendencias del estado del arte y vigilancia tecnológica.</li>
                    <li>Con autoridades entidades gubernamentales y agencias para cumplir con las leyes, normativas,
                        procesos legales o solicitudes gubernamentales exigibles; cuando lo permita o exija la ley o en
                        respuesta al cumplimiento de una ley u otra solicitud legal; para proteger los derechos de los
                        HUBS o los de un tercero, incluido el cumplimiento de esta política; recibir servicios contratados
                        o utilizar productos con licencia de proveedores externos; cumplir con cualquier orden judicial o
                        procedimiento legal; identificar al usuario de la plataforma ante cualquier persona que el
                        usuario envíe una comunicación a través de la plataforma; detectar, prevenir o abordar de
                        cualquier fraude u otra actividad delictiva o errores o problemas técnicos o de seguridad.</li>

                </ul>
                <p>Adicionalmente, los HUBS podrán compartir su información a su discreción con terceros en caso de que
                    dicha información haya sido anonimizada o en cumplimiento de requisitos legales.</p>

                <span >
                    <p className="subtitle-politica" >7 Finalidad del Tratamiento de Datos Personales</p>
                </span>
                <p>
                    Los HUBS recopilan y tratan sus datos personales para los siguientes fines:</p>
                <ul>


                    <li>Proveer acceso al sitio web y la Calculadora IRL así como los servicios asociados a dicha
                        herramienta.
                    </li><li>
                        Efectuar análisis de las respuestas ingresadas por los usuarios de la Calculadora IRL para definir
                        métricas relevantes y diseñar y/o mejorar servicios de apoyo al ecosistema I+D+i+e.
                    </li><li>
                        Desarrollar conjuntos de datos anónimos para mejorar el rendimiento de la Calculadora IRL,
                        nuevos servicios y/o transferirlos a terceros para el análisis de la oferta y/o demanda de
                        determinadas industrias.
                    </li><li>
                        Mantener registros de archivo de los usuarios que utilizan la Calculadora IRL con fines
                        estadísticos, con sujeción a los límites de retención impuestos por las leyes 19.628.
                    </li><li>
                        Detectar potenciales oportunidades y potencialidad de vinculación, que los HUBS puedan
                        identificar y promover, para el éxito de su iniciativa.
                    </li><li>
                        Mantenimiento de la Calculadora IRL.
                    </li><li>
                        Informarle de nuevas oportunidades relevantes para su iniciativa así como noticias de eventos
                        pertinentes para aquellas personas que se vinculan en el ecosistema I+D+i+e de Chile.
                    </li>
                </ul>
                <p>
                    Los datos recogidos por los HUBS podrán ser conservados y usados con fines estadísticos, siempre y
                    cuando no sea posible la identificación de sus titulares.

                </p>
                <span >
                    <p className="subtitle-politica" >8 Base Legal del Tratamiento de Datos</p>
                </span>
                <p>
                    La base legal para el Tratamiento de Datos es el consentimiento del usuario, en tanto titular de sus
                    datos personales. Por tanto, los datos personales que se recopilan y tratan en la Plataforma provienen
                    directamente de sus titulares.</p><p>
                    Puede retirar su consentimiento en cualquier momento mediante la comunicación a cualquiera de los
                    siguientes correos electrónicos: calculadora@hubapta.com, calculadora@hubtec.cl,
                    calculadora@knowhub.cl.
                </p><p>
                    La retirada del consentimiento no tiene un efecto retroactivo en el tratamiento de datos.
                </p>
                <span >
                    <p className="subtitle-politica" >9 Medidas de Seguridad para la Protección de Datos</p>
                </span>
                <p>
                    Los HUBS se comprometen a proteger sus datos personales. Para ello, se utilizan medidas estándar de
                    seguridad de la industria (las que pueden incluir mecanismos físicos, técnicos y de procedimiento) como
                    protección contra la divulgación no autorizada de datos personales que se recolecta y conserva.
                    Adicionalmente, se han adoptado medidas razonables para garantizar que los datos personales
                    recolectados sean completos y relevantes para su uso previsto.</p>
                <p>La Plataforma puede contener links a otros sitios web de terceros, que están sujetos a las otras políticas
                    de privacidad. Los HUBS no son responsables por las prácticas de privacidad de tales sitios vinculados a
                    terceros, ni por sus propietarios u operadores.
                </p>
                <p>La plataforma podría contener widgets de redes sociales como Twitter, Facebook y LinkedIn, y otras
                    funciones que pueden recopilar información personal y datos de uso, y pueden configurar Cookies en los
                    dispositivos del usuario. Dichos widgets y funciones de redes sociales podrían ser alojados por un
                    tercero. Los HUBS no son responsables del funcionamiento de dichos widgets y funciones, y cualquier
                    recopilación de información estará sujeta a la política de privacidad del proveedor de dichos widgets y
                    funciones, y no a esta Política de Privacidad.</p>
                <p>Cabe señalar que la seguridad absoluta no se puede garantizar y no existe ningún sistema de seguridad
                    que sea impenetrable por lo que, en el caso de cualquier información objeto de tratamiento y bajo
                    control de los HUBS se viese comprometida como consecuencia de una brecha de seguridad, se tomarán
                    las medidas adecuadas para investigar el incidente, notificarlo a la autoridad que correspondiere y, en su
                    caso, a aquellas personas que se hubieran podido ver afectadas para que tomen las medidas adecuadas.
                </p>
                <span >
                    <p className="subtitle-politica" >10 Derechos de los Titulares de Datos</p>
                </span>
                <p>
                    La ley 19.628 permite que los usuarios, en tanto titulares de sus datos personales, puedan ejercer sus
                    derechos de acceso, rectificación, supresión, oposición, portabilidad y bloqueo de sus datos personales,
                    así como a no ser objeto de decisiones automatizadas, cuando proceda.
                </p>
                <p>
                    En efecto, los usuarios contarán con los siguientes derechos:
                </p>
                <ul>
                    <li>
                        Solicitar y obtener información sobre sus datos personales tratados y su origen, su finalidad,
                        categoría de destinatarios y período de almacenamiento.
                    </li><li>
                        Solicitar la rectificación de sus datos personales, cuando estos sean inexactos, estén
                        desactualizados o sean incompletos.
                    </li><li>
                        Solicitar la cancelación o supresión de sus datos personales cuando así lo desee.
                    </li><li>
                        Oponerse al tratamiento de sus datos personales según lo dispuesto en la ley 19.628.
                    </li><li>
                        Solicitar y recibir copia de sus datos personales para transferirlos a terceros.
                    </li><li>
                        Oponerse a ser objeto de decisiones basadas en el tratamiento automatizada de sus datos.
                    </li>
                </ul>
                <p>
                    El ejercicio de dichos derechos podrá ser realizado mediante una comunicación escrita a cualquiera de
                    los HUBS a su dirección postal o bien a través del correo electrónico, proporcionando antecedentes
                    suficientes para determinar la identidad del titular de datos personales. Así, se verificará que se
                    disponen de suficientes garantías sobre la identidad del solicitante previo a la respuesta sobre su
                    solicitud.
                </p>
                <ul>
                    <li>
                        APTA<br></br>
                        Domicilio postal: El Director 6000, oficina 203, Las Condes, Santiago, Chile.
                        Correo electrónico: <a href={"mailto:calculadora@hubapta.com"}>calculadora@hubapta.com</a></li>
                    <li>HUBTEC<br></br>
                        Domicilio postal: Av. Apoquindo 2827, Piso 12, Las Condes, Santiago, Chile.
                        Correo electrónico: <a href={"mailto:calculadora@hubtec.cl"}>calculadora@hubtec.cl</a></li>
                    <li>
                        Know Hub<br></br>
                        Domicilio postal: Av. Nueva Tajamar 481, Oficina 905 Torre Norte, Las Condes, Santiago, Chile.
                        Correo electrónico: <a href={"mailto:calculadora@knowhub.cl"}>calculadora@knowhub.cl</a>
                    </li>
                </ul>
                <p>
                    Pueden existir exenciones o restricciones respecto al bloqueo o supresión de datos personales según la
                    ley 19.628 vigente a la época de la solicitud.
                </p>

                <span >
                    <p className="subtitle-politica" >11 Transferencia Internacional de Datos</p>
                </span>
                <p>Al utilizar la Plataforma o proporcionar sus datos personales en forma electrónica, usted está
                    transfiriendo su información directamente a Chile. Además, sus datos personales y datos de uso
                    también se pueden transferir y procesar en otros países donde se encuentre nuestro personal o
                    proveedores de servicios de terceros. Chile y esos otros países podrían no tener el mismo nivel de
                    protección de la información que la jurisdicción del miembro del centro o usuario.
                </p><p>
                    Por medio de la aceptación a la Política, usted está consintiendo expresamente dicha transferencia (con
                    ello al procesamiento de la misma) al enviar dicha información.
                </p><p>
                    Los HUBS tomarán todas las medidas razonablemente necesarias para garantizar que sus datos
                    personales y de uso sean tratados de forma segura y de acuerdo con esta Política de Privacidad. En todo
                    caso, no realizaremos ninguna transferencia de datos personales a una organización o país, a menos que
                    existan controles adecuados y seguros.</p>
                <span >
                    <p className="subtitle-politica" >12 Período de Almacenamiento de Datos</p>
                </span>
                <p>
                    Los HUBS retendrán sus datos personales por el período de tiempo necesario para cumplir con la
                    finalidad para la cual fueron recogidos, dar cumplimiento a obligaciones legales y atender las eventuales
                    responsabilidades que pudieran derivar del cumplimiento de la finalidad por la que sus datos fueron
                    recopilados.</p>
                <p>
                    Adicionalmente, cuando la ley requiera retener los datos personales por más tiempo o cuando se
                    requiera para poder defender a los HUBS contra demandas judiciales, se retendrá su información
                    personal hasta el final del período de retención pertinente o hasta que las demandas en cuestión hayan
                    sido resueltas.</p>
                <p>
                    Los HUBS conservarán los datos de uso para fines de análisis interno. Estos generalmente se conservan
                    por un período de tiempo más corto, excepto cuando estos datos se usan para fortalecer la seguridad o
                    mejorar la funcionalidad del servicio, o exista una obligación legal que implique retener estos datos por
                    períodos de tiempo más largos.
                </p>
                <span >
                    <p className="subtitle-politica" >13 Modificaciones de la Política</p>
                </span>
                <p>
                    Es posible que los HUBS actualicen esta Política. La fecha en que se revisó por última vez esta Política de
                    Privacidad se identifica en la parte final del presente documento. Las modificaciones a la Política serán
                    publicadas en esta página web.
                </p>
                <span >
                    <p className="subtitle-politica" >14 Fecha de elaboración de la Política</p>
                </span>
                <p>
                    La presente Política ha sido elaborada con fecha de 14 de marzo de 2025.
                </p>

                <span >
                    <p className="subtitle-politica" >15 Contacto</p>
                </span>
                <p>
                    Si tiene dudas sobre esta Política puede dirigirse a cualquiera de los siguientes correos electrónicos:
                    <a href={"mailto:calculadora@hubapta.com"}>calculadora@hubapta.com</a>, <a href={"mailto:calculadora@hubtec.cl"}>calculadora@hubtec.cl</a>, <a href={"mailto:calculadora@knowhub.cl"}>calculadora@knowhub.cl</a>.
                </p>


            </div>



        </div>


    )

};
